export default {"theme":{"dark":false,"themes":{"light":{"primary":"#005f97","accent":"#0fdb7e","secondary":"#476c78","info":"#00bcd4","warning":"#ffc107","error":"#e53935","success":"#0fdb7e"}}}}
